import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { cn } from '@/app/utils';

interface TagInterface {
  className?: string;
  text?: string;
  tooltipContent?: React.ReactNode;
}

export const FeedTag = ({ text, className, tooltipContent }: TagInterface) => {
  return text ? (
    <CustomTooltip content={tooltipContent} trigger="hover" disableHoverableContent={true}>
      <div className={cn('rounded-6 bg-system-black/30 px-2 py-0.5 text-xs backdrop-blur-sm', className)}>{text}</div>
    </CustomTooltip>
  ) : null;
};
